export const OutboxStatus = {
    PENDING: 'PENDING',
    SENDING: 'SENDING',
    SENT: 'SENT',
    FAILED: 'FAILED',
};
/** Значення в порядку оголошення в схемі. */
export const OUTBOX_STATUS_VALUES = ['PENDING', 'SENDING', 'SENT', 'FAILED'];
export const OUTBOX_STATUS_LABELS = {
    PENDING: 'Очікує',
    SENDING: 'Надсилається',
    SENT: 'Надіслано',
    FAILED: 'Помилка',
};
export const OUTBOX_STATUS_TONES = {
    PENDING: 'neutral',
    SENDING: 'info',
    SENT: 'success',
    FAILED: 'danger',
};
//# sourceMappingURL=outbox-status.js.map